<template>
	<div class="MainBox">
    <!-- 面包屑导航 -->
    <K-Column :column="column"></K-Column>

    <!-- 表格内容 -->
    <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
    <table class="table StripeTable" v-else>
      <thead>
        <tr>
          <th>码标</th>
          <th>名称</th>
          <th>手机号</th>
          <th v-if="showRow">医生姓名</th>
          <th v-if="showRow">医疗机构名称</th>
          <th v-if="showRow">手术日期</th>
          <th v-if="showRow">咨询师12位识别码</th>
          <th>查询内容</th>
          <th>查询时间</th>
        </tr>
      </thead>
      <tbody class="TRHoverStyle">
        <tr v-for="(item,index) in datas" v-bind:key="index">
          <td v-text="item.code"></td>
          <td v-text="item.name"></td>
          <td v-text="item.phone"></td>
          <td v-if="showRow" v-text="item.doctorName"></td>
          <td v-if="showRow" v-text="item.companyName"></td>
          <td v-if="showRow" v-text="item.date"></td>
          <td v-if="showRow" v-text="item.idcode"></td>
          <td v-text="item.content"></td>
          <td v-text="item.created_at"></td>
        </tr>
      </tbody>
    </table>

    <!-- 分页器 -->
    <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>
	</div>
</template>

<script>
var self;
import axios from 'axios'
import Column from '@/components/common/Column.vue'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
export default {
  name: 'FeedbackRecord',
  components: {
    'K-Column': Column,
    'K-Paging': Paging,
    'K-Transition': Transition
  },
  data () {
    return {
      column:[
        {name:'反馈记录',url:'FeedbackRecord'}
      ],
      page:1,
      subHint:'数据加载中...',
      isLoding:true,
      totalPages:0,
      datas:null,
      rootid: '',
      showRow: false,
    }
  },
  created () {
    self = this;
    self.rootid = localStorage.getItem("wwmxt_Rootid");
    self.showRow = ['100010392'].includes(self.rootid);
  },
  mounted () {
    self.GetList();
  },
  methods: {
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+`feelback_list/${self.page}`).then(function (response){
        self.isLoding = false;
        let datas = response.data.meta.data;
        self.datas = datas.map(item=>{
          item.rootName = item.name;
          let obj = {};
          if(item.attr){
            try {
              obj = JSON.parse(item.attr);
            } catch (error) {}
          }
          return {...item, ...obj};
        });
        if(!datas.length){
          self.datas = null;
          self.subHint = "无信息！";
        }
        self.totalPages = response.data.meta.last_page;  //总页数
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    }
  }
}
</script>

<style scoped>
th{
  padding:20px !important;
}
td{
  padding:20px !important;
}
</style>
